<template>
  <div class="interactive-list-item accordion-item" :class="{'show' : show}">
    <a
      :href="'#' + idx"
      class="link"
      @click="click"
      role="button"
      :aria-label="title"
    >
      <h2 class="label dark">
        <span class="span">{{title}}</span>
      </h2>
    </a>
    <VueCollapse :show="show" :duration="duration">
      <section
        class="accordion-item-content"
        :id="idx"
        :aria-expanded="show"
      >
        <slot />
      </section>
    </VueCollapse>
  </div>
</template>

<script>
  import VueCollapse from './VueCollapse.vue';

  export default {
    name:       'VueAccordionItem',

    components: {
      VueCollapse,
    },

    props:      {
      title:    {
        type:     String,
        required: true,
      },
      initOpen: {
        type:     Boolean,
        required: false,
        default:  false,
      },
      reducedMotion: {
        required: true,
      }
    },

    data(){
      return {
        id: null,     // Used for linking to anchor
        idx:  null,   // For communication with parent
        open: false,  // State of item
      }
    },

    computed:   {
      show() {
        return this.open;
      },

      duration() {
        if (this.reducedMotion){
          return 0
        }
        else{
          return 700
        }
      },
    },

    methods:    {
      click(e) {
        e.preventDefault()
        this.$parent.openItem(this.idx);
      },
    },

    created() {
      if (this.$parent) {
        this.$parent.register(this);
      }
    },

    mounted(){
      this.id = this._uid
    }

  };
</script>

<style scoped lang="scss">

@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.accordion-item {
  position: relative;
  display: block;

  // Chevron
  &::after{
    content: "";
    display: block;
    position: absolute;
    top: 1.5* $medium +rem;
    right: 0.3rem;
    height: $medium+rem;
    width: $medium+rem;
    border-right: 2px solid $color-dark;
    border-bottom: 2px solid $color-dark;
    transform: rotate(-45deg);
    pointer-events: none;

    transition:
      transform $duration-long+ms $ease-out-expo,
      border-color $duration-short+ms ease-in;
  }

  // Expanded state
  &.show{

    // Chevron
    &::after{
      transform: rotate(45deg);
    }
  }
}

.link,
.link:hover,
.link:focus,
.link:active{
  -webkit-tap-highlight-color: rgba(0,0,0,0);

  .label{

    .span{
      @include regular-text;
      transform-origin: left center;

      .with-motion &{
        transition: transform 700ms $ease-out-expo;
      }
      // Expanded state
      .show &{
        @include bold-text;
        transform: scale($font-size-h2/$font-size-h3);
        line-height: 1;
      }
    }
  }
}
// Hover, Focus, Active styles
.link:hover,
.link:focus,
.link:active{
  text-decoration: none;
  outline: none;

  .label{

    span{

      .no-touch-events &{
        @include bold-text;
      }
    }
  }
}

.no-touch-events{

  .interactive-list-item{

    .link:focus{

      .label{
        outline: 1px dotted $black;
      }
    }
  }
}

.accordion-item-content {
  position: relative;
  margin-top: $medium+rem;
  z-index: 0;
}
</style>

<style lang="scss">
@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.accordion-item-content{

  &>*:last-child{
    margin-bottom: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VueAccordionItem.vue